import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SidenavMenu } from '../../interfaces/UI/i-menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  showDbObjectView: Subject<boolean> = new Subject<boolean>();
  public url = 'assets/data/';
  menu : SidenavMenu[];
  titleName : Subject<string>

  constructor(
    public http: HttpClient,
  ) { 
    this.titleName = new Subject<string>();
  }

  public getMenu(): Observable<SidenavMenu[]> {
    return this.http.get<SidenavMenu[]>(this.url + 'menu.json');
  }
  public getLocalMenu(){
    return this.menu;
  }
  public setMenu(_menu : SidenavMenu[]){
    this.menu = _menu;
    
  }

  
}
